import React from "react";

interface TextBoldWhiteProps {
  text: String;
  onClick: () => void;
  color?:string;
}

const UnderlineTextButtonItalic: React.FC<TextBoldWhiteProps> = ({
  text,
  onClick,
  color='shopNow'
}) => {
  return (
    <div
      onClick={onClick}
      className={`text-[32px] sm-custom:text-[15px] text-${color} font-psItalic transition-transform duration-300 hover:scale-110 cursor-pointer underline`}
    >
      {text}
    </div>
  );
};

export default UnderlineTextButtonItalic;
